var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPdf)?_c('pdf',{attrs:{"src":"nissin-term.pdf","page":1},on:{"loaded":_vm.onPdfLoad}}):_vm._e(),(_vm.isPdf)?_c('pdf',{attrs:{"src":"page-2.pdf","page":1},on:{"loaded":_vm.onPdfLoad}}):_c('div',{staticClass:"p-3 bg-white"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.policy)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }